module.exports = __webpack_public_path__ + "static/media/login-bg-2-warning.48637307.png";